import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'reactstrap';
import { deviceStatusConverter } from 'utils/patientDeviceStatus';
import { ReadingTypes } from 'constants/readingTypes';

const Devices = ({ devices, adminPage }) => (
  <>
    {!adminPage && <h5>Devices</h5>}
    <Table borderless border="0" cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th>
            <div className="pagination-container">
              <h5>Type</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Number</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Reading Type</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Status</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Date</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {devices.map((device) => (
          <tr
            key={device.deviceId}
            className={classnames(
              { 'disabled-device': !device.isActive },
              { 'enabled-device': device.isActive },
            )}
          >
            <td>{device.manufacturer}</td>
            <td>
              <div>{device.deviceId}</div>
            </td>
            <td>
              {device.readingTypes.map((d) => (
                <p>{ReadingTypes[d]}</p>
              ))}
            </td>
            <td>{deviceStatusConverter(device.isActive)}</td>
            <td>{device.statusUpdatedAt}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
);

Devices.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      deviceId: PropTypes.string,
      manufacturer: PropTypes.string,
      isActive: PropTypes.bool,
      statusUpdatedAt: PropTypes.string,
    }),
  ).isRequired,
  adminPage: PropTypes.bool,
};

export default Devices;
